import { type CSSProperties, type ReactNode } from "react";
import { Tabs as AntdTabs, Space, theme } from "antd";

import type { AvE2EProps } from "../../types";

type TabDefinition = {
  key: string;
  label: ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  visible?: boolean;
};

export type ProfileTabProps = {
  tabs: TabDefinition[];
  defaultTab: string;
  activeTab: string;
  onChange?: (tab: string) => void;
  tabBarStyle?: CSSProperties;
} & AvE2EProps;

function Tabs(props: ProfileTabProps) {
  const { tabs, activeTab, defaultTab, onChange, testIdPrefix, tabBarStyle } = props;
  const { token } = theme.useToken();

  return (
    <AntdTabs
      data-testid={`${testIdPrefix}-tab`}
      defaultActiveKey={defaultTab}
      activeKey={activeTab}
      onChange={onChange}
      tabBarStyle={{
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        marginBottom: "8px",
        ...tabBarStyle,
      }}
      items={tabs
        .filter((tab) => tab.visible ?? true)
        .map((tab) => ({
          key: tab.key,
          label: (
            <Space data-testid={`${testIdPrefix}-tab-${tab.key}`}>
              {tab.icon}
              {tab.label}
            </Space>
          ),
          children: tab.children,
        }))}
    />
  );
}

export { Tabs };
